import React from 'react';

import BillingDetailsCard from './subcomponents/billingDetailsCard';
import SubscriptionCard from './subcomponents/subscriptionCard';
import UpgradeSuccessfulAlert from './subcomponents/upgradeSuccessfulAlert';
import CancelSubscriptionCard from './subcomponents/cancelSubscriptionCard';

const BillingSettings = () => (
  <>
    <UpgradeSuccessfulAlert />
    <SubscriptionCard />
    <BillingDetailsCard />
    <CancelSubscriptionCard />
  </>
);
export default BillingSettings;
